import React, { Component } from "react";
import {
  Row,
  Col,
  Input,
  Button,
  Card,
  CardBody,
  InputGroupAddon,
  FormGroup,
} from "reactstrap";
import _ from "lodash";
import { Redirect, withRouter } from '../../utils/router-compat';
import classnames from "classnames";
import Sidebar from "react-sidebar";
import "./SalesReport.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import SalesReportDataTableFM from "../../components/SalesReport/SalesReportDataTableFM";
import AddSalesDataFM from "../../components/SalesReport/AddSalesDataFM";
import StorageService from "../../services/Storage";
import SalesReportDataTableZFM from "../../components/SalesReport/SalesReportDataTableZFM";
import SalesReportService from "../../services/SalesReportService";
import CustomSpinner from "../../components/CustomSpinner/CustomSpinner";
import { downlodFile } from "../../utils/utils";
import { Roles } from "../../constants/constant.role";

class SalesReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      years: this.getYears(),
      months: this.getMonths(),
      selectedYear: new Date().getFullYear(),
      selectedMonth: this.getSelectedMonth(),
      userDetail: StorageService.getUserDetail(),
      sidebarOpen: false,
      redirectToMemberSalesDetail: false,
      isMonthPickerOpen: false,
      isLoading: false,
      fleetSalesFM: [],
      zoneName: "All India",
      zone: "all",
      totalFleetSalesFM: {
        tbr: {},
        tbb: {},
        customer: {}
      },
      selectedMember: {}
    };
  }

  componentWillMount() {
    this.setState({ isLoading: true });
    setTimeout(() => {
      this.setState({ isLoading: false });
    }, 1000);
  }

  componentDidMount() {
    let { isLoading, isMonthPickerOpen } = this.state;
    this.setState({ isLoading });
    this.callGetAPIs();

    const that = this;
    window.addEventListener("click", function handleClick(e) {
      if (
        (document.getElementById("monthYearCalendarDiv") &&
          document.getElementById("monthYearCalendarDiv").contains(e.target)) ||
        (document.getElementById("monthYearCalendarInput") &&
          document.getElementById("monthYearCalendarInput").contains(e.target))
      ) {
        // Clicked in box
        isMonthPickerOpen = true;
        that.setState({ isMonthPickerOpen });
      } else {
        isMonthPickerOpen = false;
        that.setState({ isMonthPickerOpen });
        // Clicked outside the box
      }
    });
  }

  openMonthPicker = () => {
    let { isMonthPickerOpen } = this.state;
    isMonthPickerOpen = !isMonthPickerOpen;
    this.setState({ isMonthPickerOpen });
  };

  getYears = () => {
    const arr = [];
    for (let i = new Date().getFullYear(); i >= 1970; i--) {
      arr.push(i);
    }

    return arr;
  };

  getMonths = () => {
    return [
      {
        label: "Jan",
        value: 1
      },
      {
        label: "Feb",
        value: 2
      },
      {
        label: "Mar",
        value: 3
      },
      {
        label: "Apr",
        value: 4
      },
      {
        label: "May",
        value: 5
      },
      {
        label: "Jun",
        value: 6
      },
      {
        label: "Jul",
        value: 7
      },
      {
        label: "Aug",
        value: 8
      },
      {
        label: "Sep",
        value: 9
      },
      {
        label: "Oct",
        value: 10
      },
      {
        label: "Nov",
        value: 11
      },
      {
        label: "Dec",
        value: 12
      }
    ];
  };

  getSelectedMonth = () => {
    return _.find(this.getMonths(), { value: new Date().getMonth() + 1 });
  };

  handleYearChange = e => {
    let { selectedYear, isLoading } = this.state;
    selectedYear = e.target.value;
    isLoading = true;
    this.setState({ selectedYear, isLoading }, () => {
      this.callGetAPIs();
    });
  };

  handleMonthChange = obj => {
    let { selectedMonth, isMonthPickerOpen, isLoading } = this.state;
    selectedMonth = obj;
    isLoading = true;
    isMonthPickerOpen = !isMonthPickerOpen;

    this.setState({ selectedMonth, isMonthPickerOpen, isLoading }, () => {
      this.callGetAPIs();
    });
  };

  openCloseSideBar = param => {
    let { sidebarOpen } = this.state;
    sidebarOpen = !sidebarOpen;
    if (sidebarOpen) {
      document.body.style.overflowY = "hidden";
    } else {
      document.body.style.overflowY = "auto";
    }
    if (param === "fetchData") {
      this.callGetAPIs();
    }
    this.setState({ sidebarOpen });
  };

  goToMemberSalesReport = obj => {
    const { selectedMember } = this.state;
    let { redirectToMemberSalesDetail } = this.state;
    selectedMember.uuid = window.btoa(obj.uuid);
    selectedMember.name = window.btoa(obj.business_name);
    selectedMember.memberId = window.btoa(obj.member_id);
    selectedMember.location = window.btoa(obj.region_name);
    redirectToMemberSalesDetail = true;
    this.setState({ redirectToMemberSalesDetail, selectedMember });
  };

  callGetAPIs = async () => {
    const { userDetail } = this.state;
    if (userDetail.type === Roles.FLEET_MANAGER_ROLE) {
      this.getFleetSalesFM(1, 10, false);
      this.getTotalFleetSalesFM();
    } else if (
      userDetail.type === Roles.ZONAL_FLEET_MANAGER_ROLE ||
      userDetail.type === Roles.HEAD_OFFICE_BAADSHAH_ROLE
    ) {
      this.getZonalFleetSalesFM();
    }
  };

  searchFleetSalesFm = search => {
    this.getFleetSalesFM(1, 10, false, search);
  };

  getFleetSalesFM = async (page, pagesize, downloadReport, search) => {
    const { selectedMonth, selectedYear } = this.state;
    let { fleetSalesFM, isLoading } = this.state;
    try {
      isLoading = true;
      this.setState({ isLoading });
      const { data } = await SalesReportService.getFleetSalesFM({
        month: selectedMonth.value,
        year: selectedYear,
        page,
        pagesize,
        downloadReport,
        search
      });

      if (downloadReport && data) {
        const link = document.createElement("a");
        link.href = data.data.file;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else if (data) {
        fleetSalesFM = data.data;
        fleetSalesFM.pageCount = Math.trunc(fleetSalesFM.total_count / 10) + 1;
        fleetSalesFM.page = page;
      }
      isLoading = false;
      this.setState({ isLoading, fleetSalesFM });
    } catch (error) {
      isLoading = false;
      this.setState({ isLoading });
    }
  };

  getTotalFleetSalesFM = async () => {
    const { selectedMonth, selectedYear } = this.state;
    let { totalFleetSalesFM } = this.state;
    this.setState({ isLoading: true });
    try {
      const { data } = await SalesReportService.getTotalFleetSalesFM({
        month: selectedMonth.value,
        year: selectedYear
      });
      if (data) {
        totalFleetSalesFM = data.data;
      }
      this.setState({ totalFleetSalesFM, isLoading: false });
    } catch (error) {
      this.setState({ isLoading: false });
    }
  };

  getZonalFleetSalesFM = async downloadReport => {
    const { selectedMonth, selectedYear, zone, userDetail } = this.state;
    let { fleetSalesFM, isLoading, totalFleetSalesFM } = this.state;
    let zoneData = null;
    if (userDetail.type !== Roles.ZONAL_FLEET_MANAGER_ROLE) {
      zoneData = zone;
    } else {
      zoneData = null;
    }
    try {
      isLoading = true;
      this.setState({ isLoading });
      const { data } = await SalesReportService.getSalesReportZFM(
        selectedMonth.value,
        selectedYear,
        downloadReport,
        zoneData
      );
      if (data) {
        if (downloadReport === true) {
          const { file } = data.data;
          downlodFile(file);
          this.setState({ isLoading: false });
          return;
        }
        fleetSalesFM = data.data.fm_data;
        totalFleetSalesFM = data.data;
      }
      isLoading = false;
      this.setState({ isLoading, fleetSalesFM, totalFleetSalesFM });
    } catch (error) {
      isLoading = false;
      this.setState({ isLoading });
    }
  };

  downloadZonalFleetSalesReport = () => {
    this.getZonalFleetSalesFM(true);
  };

  handlePageClick = (search, e) => {
    let { isLoading } = this.state;
    isLoading = true;
    this.setState({ isLoading });
    this.getFleetSalesFM(e.selected + 1, 10, false, search);
  };

  openTargetSalesPage = () => {
    this.props.history.push("/target-sales");
  };

  onChangeZone = e => {
    if (e.target.value) {
      if (e.target.value == "sz1") {
        this.setState({ zoneName: "South 1" });
      } else if (e.target.value == "sz2") {
        this.setState({ zoneName: "South 2" });
      } else if (e.target.value == "ez") {
        this.setState({ zoneName: "East" });
      } else if (e.target.value === "nz") {
        this.setState({ zoneName: "North" });
      } else if (e.target.value === "wz") {
        this.setState({ zoneName: "West" });
      }
    } else {
      this.setState({ zoneName: "All India" });
    }

    this.setState(
      {
        zone: e.target.value
      },
      () => {
        this.getZonalFleetSalesFM(false);
      }
    );
  };

  render() {
    const {
      isLoading,
      selectedMember,
      totalFleetSalesFM,
      fleetSalesFM,
      userDetail,
      redirectToMemberSalesDetail,
      isMonthPickerOpen,
      years,
      months,
      selectedMonth,
      selectedYear,
      sidebarOpen
    } = this.state;
    return (
      <div id="sales">
        {redirectToMemberSalesDetail && (
          <Redirect
            to={{
              pathname: "/memberSalesDetail",
              search: `?uuid=${selectedMember.uuid}&memberId=${selectedMember.memberId}&name=${selectedMember.name}&location=${selectedMember.location}&month=${selectedMonth.value}&year=${selectedYear}&label=${selectedMonth.label}`
            }}
          />
        )}
        {isLoading && <CustomSpinner />}
        <Row>
          <Col className="offtake-title">Sales Report</Col>

          <Col className="offtake-title">
            {userDetail.type === Roles.FLEET_MANAGER_ROLE && (
              <Button
                type="button"
                className="mb-1 mr-1 btn-pill action-button profile-save-button pull-right"
                color="warning"
                style={{ cursor: "pointer" }}
                onClick={this.openCloseSideBar}
              >
                Enter Sales
              </Button>
            )}

            {userDetail.type === Roles.ZONAL_FLEET_MANAGER_ROLE && (
              <Button
                type="button"
                className="mb-1 mr-1 btn-pill action-button profile-save-button pull-right"
                color="warning"
                style={{ cursor: "pointer" }}
                onClick={this.openTargetSalesPage}
              >
                Set Target
              </Button>
            )}
          </Col>
        </Row>

        <br />

        <Row>
          <Col xl="3" md="3" sm="3" xs="3">
            <div
              id="monthYearCalendarInput"
              className="d-flex-row vehical-sku-id-search"
            >
              <Input
                className="form-control"
                type="text"
                name="sap_id"
                value={
                  selectedMonth && `${selectedMonth.label} ${selectedYear}`
                }
                onClick={this.openMonthPicker}
                readOnly
                style={{ background: "white" }}
                placeholder="Select Month"
              />
              <InputGroupAddon
                onClick={this.openMonthPicker}
                addonType="append"
                className="serach-icon"
                style={{ marginTop: "0px" }}
              >
                <div
                  className="input-group-text"
                  style={{ paddingRight: "5px", marginTop: "-1px" }}
                >
                  <FontAwesomeIcon icon={faCalendarAlt} />
                </div>
              </InputGroupAddon>
            </div>
          </Col>
          {this.state.userDetail.type === Roles.HEAD_OFFICE_BAADSHAH_ROLE && (
            <Col xl="2" md="2" sm="3" xs="3">
              <FormGroup>
                <select
                  name="month"
                  className="form-control cursor-pointer"
                  value={this.state.zone}
                  style={{
                    fontSize: "13px",
                    width: "140px",
                    color: "#6e777f",
                    marginLeft: "-20px"
                  }}
                  onChange={e => {
                    this.onChangeZone(e);
                  }}
                >
                  <option value="all" selected>
                    All India
                  </option>
                  <option value="nz" selected>
                    North
                  </option>
                  <option value="sz1">South 1</option>
                  <option value="sz2">South 2</option>
                  <option value="ez">East</option>
                  <option value="wz">West</option>
                </select>
              </FormGroup>
            </Col>
          )}
        </Row>
        {StorageService.getUserDetail().type === Roles.HEAD_OFFICE_BAADSHAH_ROLE && (
          <Col style={{ paddingLeft: "0px" }}>
            <div className="zoneFont">
              Showing results of{" "}
              {this.state.zoneName === "All India"
                ? this.state.zoneName
                : this.state.zoneName + " Zone"}
              .
            </div>
          </Col>
        )}

        {isMonthPickerOpen && (
          <Row
            id="monthYearCalendarDiv"
            style={{ position: "absolute", zIndex: "200" }}
          >
            <Col xl="4" md="4" sm="4" xs="4">
              <Card style={{ width: "97%" }}>
                <CardBody>
                  <Row>
                    <Col>
                      <select
                        className="form-control"
                        name="selectedYear"
                        onChange={e => this.handleYearChange(e)}
                        value={selectedYear}
                      >
                        {(years || []).map(year => (
                          <option key={year}>{year}</option>
                        ))}
                      </select>
                    </Col>
                  </Row>

                  <Row className="c-top-10">
                    {(months || []).map(month => (
                      <Col xl="4" md="4" sm="3" xs="3" key={month.value}>
                        <div>
                          <Button
                            className="btn-month"
                            color="default"
                            onClick={e => this.handleMonthChange(month)}
                          >
                            {month.label}
                          </Button>
                        </div>
                      </Col>
                    ))}
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        )}

        <Row style={{ marginTop: "20px" }}>
          <Col xl="4" md="4" sm="12" xs="12">
            <div
              className={classnames(
                { "mr-3": !this.isMobile },
                "fm-points-card total-points-card"
              )}
              style={{ paddingBottom: "0px" }}
            >
              <Row>
                <Col xl="3" md="3" sm="12" xs="12">
                  <div className="fm-trucks">TBR</div>
                </Col>
                <Col xl="5" md="5" sm="12" xs="12">
                  <div className="direct-indirect-sales-value ml-3">Achieve / Target</div>
                </Col>
                <Col>
                  <div className="direct-indirect-sales-value">
                    % Achievement
                  </div>
                </Col>
              </Row>

              <Row style={{ marginLeft: "7px", marginTop: "25px" }}>
                <Col xl="4" md="4" sm="12" xs="12">
                  <div className="direct-sales-label">Direct Sales</div>
                  <br />
                  {/* <div className="direct-sales-label">Indirect Sales</div> */}
                </Col>
                <Col xl="4" md="4" sm="12" xs="12">
                  <div className="direct-indirect-sales-value">
                    {totalFleetSalesFM.tbr.direct_achievement} /{" "}
                    {totalFleetSalesFM.tbr.direct_sales}
                  </div>
                  <br />
                  {/* <div className="direct-indirect-sales-value">
                    {totalFleetSalesFM.tbr.indirect_achievement} /{" "}
                    {totalFleetSalesFM.tbr.indirect_sales}
                  </div> */}
                </Col>
                <Col xl="1" md="1" sm="0" xs="0">
                  <div
                    style={{
                      background: "white",
                      height: "60px",
                      width: "1px"
                    }}
                  />
                </Col>
                <Col xl="3" md="3" sm="12" xs="12">
                  <div className="direct-indirect-sales-value">
                    {totalFleetSalesFM.tbr.percent_direct_sales}%
                  </div>
                  <br />
                  {/* <div className="direct-indirect-sales-value">
                    {totalFleetSalesFM.tbr.percent_indirect_sales}%
                  </div> */}
                </Col>
              </Row>

              {/* <Row
                className="c-top-10"
                style={{
                  marginRight: "0px",
                  marginLeft: "0px",
                  background: "white",
                  paddingBottom: "10px",
                  paddingTop: "10px"
                }}
              >
                <Col xl="4" md="4" sm="12" xs="12">
                  <div className="direct-sales-label">&nbsp;Total Sales</div>
                </Col>
                <Col xl="4" md="4" sm="12" xs="12">
                  <div className="direct-indirect-sales-value">
                    &nbsp;&nbsp;{totalFleetSalesFM.tbr.total_achievement} /{" "}
                    {totalFleetSalesFM.tbr.total_sales}
                  </div>
                </Col>
                <Col xl="1" md="1" sm="0" xs="0" />
                <Col xl="3" md="3" sm="12" xs="12">
                  <div className="direct-indirect-sales-value">
                    &nbsp;&nbsp;&nbsp;
                    {totalFleetSalesFM.tbr.percent_total_sales}%
                  </div>
                </Col>
              </Row> */}
            </div>
          </Col>
          <Col xl="4" md="4" sm="12" xs="12">
            <div
              className={classnames(
                { "mr-3": !this.isMobile },
                "fm-points-card total-points-card"
              )}
              style={{ paddingBottom: "0px" }}
            >
              <Row>
                <Col xl="3" md="3" sm="12" xs="12">
                  <div className="fm-trucks">TBB</div>
                </Col>
                <Col xl="5" md="5" sm="12" xs="12">
                  <div className="direct-indirect-sales-value ml-3">Achieve / Target</div>
                </Col>
                <Col>
                  <div className="direct-indirect-sales-value">
                    % Achievement
                  </div>
                </Col>
              </Row>

              <Row style={{ marginLeft: "7px", marginTop: "18px" }}>
                <Col xl="4" md="4" sm="12" xs="12">
                  <div className="direct-sales-label">Direct Sales</div>
                  <br />
                  {/* <div className="direct-sales-label">Indirect Sales</div> */}
                </Col>
                <Col xl="4" md="4" sm="12" xs="12">
                  <div className="direct-indirect-sales-value">
                    {totalFleetSalesFM.tbb.direct_achievement} /{" "}
                    {totalFleetSalesFM.tbb.direct_sales}
                  </div>
                  <br />
                  {/* <div className="direct-indirect-sales-value">
                    {totalFleetSalesFM.tbb.indirect_achievement} /{" "}
                    {totalFleetSalesFM.tbb.indirect_sales}
                  </div> */}
                </Col>
                <Col xl="1" md="1" sm="0" xs="0">
                  <div
                    style={{
                      background: "white",
                      height: "60px",
                      width: "1px"
                    }}
                  />
                </Col>
                <Col xl="3" md="3" sm="12" xs="12">
                  <div className="direct-indirect-sales-value">
                    {totalFleetSalesFM.tbb.percent_direct_sales}%
                  </div>
                  <br />
                  {/* <div className="direct-indirect-sales-value">
                    {totalFleetSalesFM.tbb.percent_indirect_sales}%
                  </div> */}
                </Col>
              </Row>

              {/* <Row
                className="c-top-10"
                style={{
                  marginRight: "0px",
                  marginLeft: "0px",
                  background: "white",
                  paddingBottom: "10px",
                  paddingTop: "10px"
                }}
              >
                <Col xl="4" md="4" sm="12" xs="12">
                  <div className="direct-sales-label">&nbsp;Total Sales</div>
                </Col>
                <Col xl="4" md="4" sm="12" xs="12">
                  <div className="direct-indirect-sales-value">
                    &nbsp;&nbsp;{totalFleetSalesFM.tbb.total_achievement} /{" "}
                    {totalFleetSalesFM.tbb.total_sales}
                  </div>
                </Col>
                <Col xl="1" md="1" sm="0" xs="0" />
                <Col xl="3" md="3" sm="12" xs="12">
                  <div className="direct-indirect-sales-value">
                    &nbsp;&nbsp;&nbsp;
                    {totalFleetSalesFM.tbb.percent_total_sales}%
                  </div>
                </Col>
              </Row> */}
            </div>
          </Col>

          <Col xl="4" md="4" sm="12" xs="12">
            <div
              className={classnames(
                { "mr-3": !this.isMobile },
                "fm-points-card total-points-card"
              )}
              style={{ paddingBottom: "0px" }}
            >
              <Row>
                <Col xl="8" md="8" sm="12" xs="12">
                  <div className="fm-trucks">Fleets</div>
                </Col>
              </Row>

              <Row style={{ marginLeft: "7px", marginTop: "18px" }}>
                <Col xl="6" md="6" sm="12" xs="12">
                  <div className="direct-sales-label">Total Fleets</div>
                  <br />
                  <div className="direct-sales-label">Fleet With Offtake</div>
                </Col>
                <Col>
                  <div className="direct-indirect-sales-value">
                    {totalFleetSalesFM.customer &&
                      totalFleetSalesFM.customer.total}
                  </div>
                  <br />
                  <div className="direct-indirect-sales-value">
                    {totalFleetSalesFM.customer &&
                      totalFleetSalesFM.customer.active}
                  </div>
                </Col>
              </Row>

              <Row
                className="c-top-10"
                style={{
                  marginRight: "0px",
                  marginLeft: "0px",
                  background: "white",
                  paddingBottom: "10px",
                  paddingTop: "10px"
                }}
              >
                <Col xl="6" md="6" sm="12" xs="12">
                  <div className="direct-sales-label">
                    &nbsp;% of Fleet With Offtake
                  </div>
                </Col>
                <Col>
                  <div className="direct-indirect-sales-value">
                    &nbsp;&nbsp;
                    {totalFleetSalesFM.customer &&
                      totalFleetSalesFM.customer.percent}
                    %
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>

        <Row className="c-top-20">
          <Col>
            {userDetail.type === Roles.FLEET_MANAGER_ROLE && (
              <SalesReportDataTableFM
                fleetSalesFM={fleetSalesFM}
                getFleetSalesFM={this.getFleetSalesFM}
                goToMemberSalesReport={this.goToMemberSalesReport}
                searchFleetSalesFm={this.searchFleetSalesFm}
                handlePageClick={this.handlePageClick}
              />
            )}

            {(userDetail.type === Roles.ZONAL_FLEET_MANAGER_ROLE ||
              userDetail.type === Roles.HEAD_OFFICE_BAADSHAH_ROLE) && (
                <SalesReportDataTableZFM
                  fleetSales={fleetSalesFM}
                  goToMemberSalesReport={this.goToMemberSalesReport}
                  downloadReport={this.downloadZonalFleetSalesReport}
                />
              )}
          </Col>
        </Row>

        <Row>
          <Col>
            <Sidebar
              sidebar={
                <AddSalesDataFM openCloseSideBar={this.openCloseSideBar} />
              }
              open={sidebarOpen}
              sidebarClassName="subsdiaries-sidebar"
              pullRight
              styles={{
                sidebar: { background: "white", height: "100%", width: "35%" }
              }}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

export default withRouter(SalesReport);
